import { Injectable } from '@angular/core';
import { HandlerService } from '../comunicator-native/handler/handler';
import { Term } from './model/term.model';
import { TermsDataService } from './termos-data.service';

@Injectable({
  providedIn: 'root'
})
export class TermsDataMobileService implements TermsDataService{

  constructor(private handlerService: HandlerService) {}

  public getTerms(type: string): Promise<Term> {
    const relCaronte = 'user-term-v2';

    return this.handlerService.caronteCommunicator(relCaronte, {tipo_termo: type}, null).then((data: any) => {
      if (data && data.data) {
        return Promise.resolve({
          title: data.data.titulo,
          description: data.data.texto,
          type
        });
      } else {
        return Promise.reject();
      }
    })
    .catch((error) => {
      return Promise.reject(error);
    });
  }
}

